export default "__VITE_ASSET__BDAv_96E__"